import { ArticleResult } from "interface/article"
import { dateFormat, formatDate, safeParseDate, safeParseInt } from "shared/util"

const parthEnglishMonth = (text: string) => {
  if (text.startsWith('Ja' ) || text === '01' || text === '1') return 1 - 1
  if (text.startsWith('Fe' ) || text === '02' || text === '2') return 2 - 1
  if (text.startsWith('Mar') || text === '03' || text === '3' || text === 'Spring') return 3 - 1
  if (text.startsWith('Ap' ) || text === '04' || text === '4') return 4 - 1
  if (text.startsWith('May') || text === '05' || text === '5') return 5 - 1
  if (text.startsWith('Jun') || text === '06' || text === '6' || text === 'Summar') return 6 - 1
  if (text.startsWith('Jul') || text === '07' || text === '7') return 7 - 1
  if (text.startsWith('Au' ) || text === '08' || text === '8') return 8 - 1
  if (text.startsWith('Se' ) || text === '09' || text === '9' || text === 'Autumn' || text === 'Fall') return 9 - 1
  if (text.startsWith('Oc' ) || text === '10') return 10 - 1
  if (text.startsWith('No' ) || text === '11') return 11 - 1
  if (text.startsWith('De' ) || text === '12' || text === 'Winter') return 12 - 1
  return null
}

export const getJournalDate = (article: ArticleResult) => {
  if (article.journal.dateText) {
    const datePart = article.journal.dateText.split(/[/-\s]/i)
    if (datePart.length > 0) {
      const year = safeParseInt(datePart[0], 0) ?? 0
      if (year > 0) {
        const month = datePart.length > 1 ? (parthEnglishMonth(datePart[1]) ?? 0) : 0
        const day = datePart.length > 2 ? (safeParseInt(datePart[datePart.length - 1], 1) ?? 0) : 1
        return formatDate(new Date(year, month, day), '-') ?? ''
      }
    }
  }
  if (article.completedDate) {
    if (article.revicedDate && article.revicedDate < article.completedDate)
      return article.revicedDate
    return article.completedDate
  }
  return article.revicedDate ?? ''
}

export const formatJournalDate = (article: ArticleResult) => {
  if (article.journal.dateText) {
    if (/[a-zA-Z]/.test(article.journal.dateText)) {
      return article.journal.dateText
    }
    const dt = safeParseDate(article.journal.dateText)
    return dt ? dateFormat(dt, { nullText: '--', wareki: false }) : article.journal.dateText
  }
  return dateFormat(getJournalDate(article), { nullText: '--' })
}